import { render, staticRenderFns } from "./ProductContentFlashCards.vue?vue&type=template&id=281bf411&scoped=true"
import script from "./ProductContentFlashCards.vue?vue&type=script&lang=js"
export * from "./ProductContentFlashCards.vue?vue&type=script&lang=js"
import style0 from "./ProductContentFlashCards.vue?vue&type=style&index=0&id=281bf411&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281bf411",
  null
  
)

export default component.exports